export default class GrpcError extends Error {
  constructor(message = '', grpcCode) {
    super(message);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GrpcError);
    }
    this.grpcCode = grpcCode;
  }
}
